import { auth } from '../firebase/config';

const ADMIN_API_URL = (import.meta.env.VITE_API_BASE_URL || '') + '/api';

const getAuthToken = async () => {
    const user = auth.currentUser;
    if (!user) throw new Error("Usuario no autenticado");
    return await user.getIdToken();
};

const fetchWithAuth = async (url, options = {}) => {
    const token = await getAuthToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers
    };
    const response = await fetch(`${ADMIN_API_URL}${url}`, { ...options, headers });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Error en la petición');
    }
    return response.json();
};

// Tags
export const getTags = () => fetchWithAuth('/tags');
export const createTag = (data) => fetchWithAuth('/tags', { method: 'POST', body: JSON.stringify(data) });
export const updateTag = (id, data) => fetchWithAuth(`/tags/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteTag = (id) => fetchWithAuth(`/tags/${id}`, { method: 'DELETE' });